import { useSelector } from "react-redux";

import { TAppState } from "store/root.store";

export const useBootstrapSelector = () => useSelector((state: TAppState) => state.bootstrapReducer);

export const useIsCookiesModalVisible = () => useSelector(getIsCookiesModalVisible);

export const getIsCookiesModalVisible = (state: TAppState) => state.bootstrapReducer.isCookiesModalVisible;
